import { useDispatch } from 'react-redux'
import { updateHosting } from '../../../../../../../actions/bot'
import { useOpenBotId } from '../../../../../../../store/app'
import { feedbotToast } from '../../../../../../../lib/feedbotToast'
import {
  useHostingVersionsCatalogueQuery,
  useSdkBuildInfo
} from '../../../../../../../features/hostingVersions'

export const useUpdateToLatestVersion = () => {
  const dispatch = useDispatch()
  const botId = useOpenBotId()

  const versionsCatalogue = useHostingVersionsCatalogueQuery()?.data?.releases
  const { latestVersion, deployedVersion } = useSdkBuildInfo() ?? {}

  return async () => {
    if (!deployedVersion || !versionsCatalogue) {
      dispatchDataLoadingProblemErrorToast()
      return
    }

    // latestVersion exists, if currently deployed version is part of release...
    // otherwise we update to the current version, resulting in update to latest commit
    const targetVersionString = latestVersion || deployedVersion.version

    const targetVersion = versionsCatalogue[deployedVersion?.releaseFamily]?.versions?.find(
      catalogueVersion => catalogueVersion.version === targetVersionString
    )

    if (!targetVersion) {
      dispatchMissingVersionErrorToast()
      return
    }

    dispatch(updateHosting(botId, targetVersion.file))
  }
}

function dispatchDataLoadingProblemErrorToast() {
  feedbotToast.error({
    title: 'Failed to update',
    content:
      'We failed to get necessary data to update the hosting version. Please contact support.'
  })
}

function dispatchMissingVersionErrorToast() {
  feedbotToast.error({
    title: 'Failed to update',
    content: 'We failed to reference the target version. Please contact support.'
  })
}
